import Paper from '@material-ui/core/Paper'
import React from 'react'
import { Typography, withStyles } from '@material-ui/core'

export const MARKDOWN = 'MARKDOWN'

const styles = theme => ({
  root: {
    margin: '5px auto',
    padding: '10px 20px'
  },
})

class ArticleTextSegment extends React.Component {
  render () {
    let {
      classes,
      // files,
      // directory,
      child,

      // ...props
    } = this.props

    return <Paper key={child.id} className={classes.root}>
      <Typography component={'div'} dangerouslySetInnerHTML={{ __html: child.formatted_content }}>
      </Typography>
    </Paper>
  }
}

export default withStyles(styles)(ArticleTextSegment)
